import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {DeliveryPackageTypeService} from 'app/blocks/service/api/delivery-package-type.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {IDeliveryPackageType} from 'app/blocks/model/delivery-package-type.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {DeliveryPackageType} from 'app/blocks/model/delivery-package-type.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class DeliveryPackageTypeResource extends AbstractEntityResource<IDeliveryPackageType> {
    constructor(deliveryPackageTypeService: DeliveryPackageTypeService, router: Router) {
        super(
            Resource.DELIVERY_PACKAGE_TYPES,
            deliveryPackageTypeService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.DELIVERY_PACKAGE_TYPES, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.DELIVERY_PACKAGE_TYPES),
            (entity?) => new DeliveryPackageType(entity),
            (entity) => entity.code,
            'style'
        );
    }
}
